import React, { useEffect } from 'react'
import Nav from '../../../components/nav/Nav'
import BannerSection from './BannerSection'
import ServiceSection from './ServiceSection'
import FeatureSection from './FeatureSection'
import SaleSection from './SaleSection'
import TradingFeatures from './TradingFeatures'
import TestimonialSection from './TestimonialSection'
import PricingSection from './PricingSection'
import FooterSection from './FooterSection'
import Navbar from './Navbar'
import ScrollToTop from '../../../components/ScrollToTop/ScrollToTop'

const LandingPage = () => {
    // Get redirect param from query params
    const [redirect, setRedirect] = React.useState(false);

    useEffect(() => {
        //get query params from URL
        const queryParams = new URLSearchParams(window.location.search);
        setRedirect(queryParams.get('redirect') === 'true');
    }, []);

    return (
        <div>
            {/* <Nav /> */}
            <Navbar redirect={redirect} />
            <BannerSection />
            <ServiceSection />
            <FeatureSection />
            <SaleSection />
            <TradingFeatures />
            <TestimonialSection />
            <PricingSection />
            <ScrollToTop />
            <FooterSection />
        </div>
    )
}

export default LandingPage